import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { GameState } from '../../interfaces/game.interface';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-kpi-page',
  templateUrl: './kpi-page.component.html',
  styleUrls: ['./kpi-page.component.scss']
})
export class KpiPageComponent implements OnInit {
  @Output() closeClick = new EventEmitter<void>();
  game_state: GameState | null = null;
  values: any = null;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.game_state = this.dataService.getGameStateSnapshot();
    const quarter = this.game_state.game_state;
    const kpi = this.game_state.kpi[quarter + "_start"]
    
    this.values = Object.keys(kpi).reduce((acc, key) => {
      acc[key] = {
        value: kpi[key],
        color: 'gray'
      };
      return acc;
    }, {} as { [key: string]: { value: number; color: string } });
  }

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
